<template>
  <div>
    <v-autocomplete v-model="form.contact"
                    ref="contactAutocomplete"
                    :disabled="form.busy"
                    :loading="loading"
                    label="Who do you want to add to this list?"
                    outlined
                    placeholder="Search for your recipient or type an email address and press ENTER."
                    prepend-inner-icon="fal fa-search"
                    :search-input.sync="search"
                    :items="normalizedContacts"
                    item-value="id"
                    item-text="name_email_company_record_type"
                    return-object
                    clearable
                    hide-details
                    @change="selectContact">
      <template v-slot:append-item
                v-if="normalizedContacts.length > 0">
        <v-list-item v-if="isAllergan">
          <strong>"{{ search }}" not found in {{ crmLabel }}.</strong>
        </v-list-item>
        <v-list-item v-else-if="search && search.trim()">
          <strong>"{{ search }}" not found.</strong>
        </v-list-item>
      </template>
      <template v-else-if="search && search.trim() && normalizedContacts.length === 0"
                v-slot:no-data>
        <v-list-item v-if="isAllergan">
          <strong>"{{ search }}" not found in {{ crmLabel }}.</strong>
        </v-list-item>
        <v-list-item v-else-if="search && search.trim()">
          <strong>"{{ search }}" not found.</strong>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import {isArray, isObject} from "lodash";
import userContactService from "../../../services/userContactService";
import validationService from "../../../services/validationService";

export default {
  data() {
    return {
      contacts: [],
      form: new Form({
        contact: null,
      }),
      loading: false,
      search: '',
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isMember',
      'crmLabel',
      'team',
      'user',
    ]),
    isAllergan() { // MLD-3127
      return this.team
        && this.team.id === 194;
    },
    normalizedContacts() {
      return this.contacts;
    },
    isContactAnObject() {
      return isObject(this.form.contact);
    },
    isContactValid() {
      return !!(isObject(this.form.contact)
        && this.form.contact.id
        && this.form.contact.email);
    },
    isSubscribed() { // MLD-2844
      return !this.isUnsubscribed;
    },
    isUnsubscribed() { // MLD-2844
      if (this.isContactAnObject) {
        return !!this.form.contact.is_unsubscribed
      }
      return false;
    },
  },
  watch: {
    search(val) {
      //console.log(`search: ${val}`);
      //if (val && val !== this.form.contact) {
      this.searchContacts(val);
      //}
    },
  },
  created() {

  },
  methods: {
    fetchContact() { // MLD-2851
      if (this.isContactValid) {
        userContactService.getContact(this.form.contact.id)
          .then(data => {
            this.form.contact = data;
          })
          .catch(() => {});
      }
    },
    searchContacts(query) {
      if (!query) {
        this.loading = false;
        this.contacts = [];
        return;
      }
      this.loading = true;
      const isEmail = validationService.isEmailValid(query);
      const form = {
        email: isEmail ? query : null,
        query: isEmail ? null : query,
        order_by: 'updated_at',
        order_dir: 'desc',
        limit: 30,
        status: 'Active', // MLD-3304
      }
      return userContactService.search(form, this.user)
        .then(data => {
          if (isArray(data.hits)) {
            this.contacts = data.hits;
          } else {
            this.contacts = data;
          }
        })
        .finally(() => {
          this.loading = false;
        })
    },
    selectContact() {
      if (isObject(this.form.contact)) {
        userContactService.getContact(this.form.contact.id) // MLD-4320
          .then(data => {
            this.$emit('selected', data);
            this.form.contact = null;
          })
          .catch(err => {
            this.form.contact = null;
          })
      }
    },
  }
}
</script>
